import { createContext, useContext, useState } from "react";

const AppContext = createContext({});

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [ appConfig, setAppConfig ] = useState({});

    return(
        <AppContext.Provider value={{ appConfig, setAppConfig }}>
            {children}
        </AppContext.Provider>
    );
}